<template>
    <div class="flex flex-col items-center justify-center space-y-2 py-6">
        <div class="py-2">
            <slot name="icon">
                <component :is="icon" />
            </slot>
        </div>

        <p class="text-neutral-base font-ux leading-base text-base font-medium">
            <slot name="title">No results found</slot>
        </p>
        <p class="text-neutral-subtle leading-sm font-ux text-sm">
            <slot name="message">Please come back later.</slot>
        </p>
    </div>
</template>

<script setup>
    const props = defineProps({
        type: {
            type: String,
            default: 'empty',
        },
    })

    const messageIcons = import.meta.glob('./icons/*.async.vue')

    const icon = defineAsyncComponent(() => {
        const iconComponent = messageIcons[`./icons/${props.type}.async.vue`]
        return iconComponent
            ? iconComponent()
            : Promise.reject(new Error(`Unknown system message icon type: ${props.type}`))
    })
</script>
